module.exports = __webpack_public_path__ + "static/img/honor_1.7433304.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/honor_1.png
// module id = y6V8
// module chunks = 15